// 顶部模板部分，弹窗表单
<template>
    <!-- el-dialog 弹窗，标题根据是否有 editData.id 判断是编辑还是新增 -->
    <el-dialog :title="editData.id ? $t('ruleConfig.editDialogTitle') : $t('ruleConfig.addDialogTitle')"
        :visible.sync="dialogVisible" width="70%" class="addConfigDialog" @close="dialogCloseHandle">
        <!-- 表单主体，绑定 formData，校验规则为 rules -->
        <el-form label-position="left" ref="addConfigForm" :rules="rules" label-width="80px" :model="formData">
            <div class="infoMode">
                <div class="common_contentBox">
                    <div class="common_search">
                        <el-row>
                            <!-- 活动层级选择 -->
                            <el-col :span="11">
                                <el-form-item :label="$t('newApp.activityInfo.csl')" prop="activityLayering">
                                    <el-select v-model="formData.activityLayering">
                                        <el-option v-for="item in activityLevelList" :key="item.fieldKey"
                                            :label="item.fieldValue" :value="item.fieldKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <!-- 申请渠道选择 -->
                            <el-col :span="11" :offset="2">
                                <el-form-item :label="$t('eventList.Afc')" prop="applyChannel">
                                    <el-select v-model="formData.applyChannel" @change="changeAfc"
                                        @visible-change="visibleAfc">
                                        <el-option v-for="item in afcList" :key="item.fieldKey" :label="item.fieldValue"
                                            :value="item.fieldKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <!-- 排序输入框 -->
                            <el-col :span="11">
                                <el-form-item :label="$t('ruleConfig.ruleSort')" prop="sort">
                                    <el-input v-model="formData.sort"
                                        @input="(val) => { inviterNumFilter('sort', val) }">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <!-- 状态开关 -->
                            <el-col :span="11" :offset="2">
                                <el-form-item :label="$t('general.Status')" prop="stat">
                                    <el-switch v-model="formData.stat" :active-value="1" :inactive-value="0" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <!-- 规则配置子组件，传递 configList 和 fieldList，加载时隐藏 -->
                <configRule :configList="configList" :fieldList="fieldList" ref="configRule" v-if="!editLoading"/>
            </div>
        </el-form>
        <!-- 底部按钮区，只有在 modeSwitch 为 false 时显示 -->
        <div slot="footer" class="dialog-footer" v-show="!modeSwitch">
            <el-button plain @click="customCloseHandle" v-show="!editData.clientName">
                {{ $t('btn.Cancel') }}
            </el-button>
            <el-button type="primary" @click="customAddHandle">{{ $t('btn.OK') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
// 引入规则配置子组件和API
import configRule from './configRule.vue';
import { newApplicationFormApi, activityRuleApi } from '../../service';
export default {
    name: 'addConfigDialog',
    components: {
        configRule
    },
    data() {
        return {
            // 控制重置加载状态
            resetLoading: true,
            // 弹窗显示状态
            dialogVisible: false,
            // 模式切换标志
            modeSwitch: false,
            // 活动层级列表
            activityLevelList: [],
            // 申请渠道列表
            afcList: [
                {
                    fieldKey: '1',
                    fieldValue: '活动申请、活动报备'
                },
                {
                    fieldKey: '2',
                    fieldValue: '快捷申请'
                },
            ],
            // 表单数据
            formData: {
                applyChannel: '1',
                stat: 1
            },
            // 表单校验规则
            rules: {
                activityLayering: [{ required: true, message: '请选择活动层级', trigger: ['blur', 'change'] }],
                applyChannel: [{ required: true, message: '请选择申请渠道', trigger: ['blur', 'change'] }],
                sort: [
                    { required: true, message: '请输入排序', trigger: ['blur', 'change'] },
                    {
                        // 排序不能超过2位
                        validator: (rule, value, callback) => {
                            if (value.length > 2) {
                                this.$set(this.formData, 'sort', 99)
                                // callback(new Error('排序不能超过2位'))
                            }
                            callback()
                        },
                        trigger: ['blur', 'change']
                    }
                ],
            },
            // 规则配置列表
            configList: [{}],
            // afc select 缓存
            afcCache: "",
            // configList 缓存
            configListCache: {},
            // 字段列表
            fieldList: [],
            // 编辑加载状态
            editLoading: false,
        }
    },
    props: {
        // 控制弹窗显示的 prop
        addConfigDialogVisible: {
            type: Boolean,
            default: false
        },
        // 编辑数据
        editData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        // 搜索回调
        search: {
            type: Function,
            default: () => {
                return () => { }
            }
        }
    },
    watch: {
        // 监听弹窗显示状态变化
        async addConfigDialogVisible(val) {
            this.configListCache = {}
            await this.initFieldList()
            if (val) {
                if (this.editData.id) {
                    // 编辑模式，回填表单和规则
                    this.editLoading = true
                    // this.formData = JSON.parse(JSON.stringify(this.editData));
                    let form = {
                        activityLayering: this.editData.activityLayering,
                        applyChannel: this.editData.applyChannel,
                        sort: this.editData.sort,
                        stat: this.editData.stat,
                    }
                    this.formData = form
                    await this.changeAfc()

                    this.configList = []
                    let index = 0
                    // 回填规则条件
                    for (let i of this.editData.ruleCondition) {
                        this.configList.push({})
                        for (let rule of i) {
                            for (let field of this.fieldList) {
                                if (rule.field === field.prop) {
                                    if (field.type === 'checkbox') {
                                        // 多选框类型
                                        this.$set(this.configList[index], rule.field, { data: field, value: rule.value.split(",") })
                                    }
                                    if (field.type === 'checkinput') {
                                        // 输入框+单选类型
                                        this.$set(this.configList[index], rule.field, {
                                            data: field,
                                            value: {
                                                radio: rule.operator,
                                                input: parseInt(rule.value)
                                            }
                                        })
                                    }
                                }
                            }
                        }
                        index++
                    }
                    this.editLoading = false
                    this.dialogVisible = val;
                } else {
                    // 新增模式，重置表单
                    this.editLoading = true
                    this.configList = [{}]
                    this.$nextTick(() => {
                        this.formData = {};
                        this.$set(this.formData, 'applyChannel', this.afcList[0].fieldKey)
                        this.$set(this.formData, 'stat', 1)
                        this.dialogVisible = val;
                        this.editLoading = false
                    })
                }
            } else {
                // 关闭弹窗时重置表单
                this.formData = {
                    applyChannel: this.afcList[0].fieldValue,
                    stat: 1
                };
                this.dialogVisible = val;
            }
            await this.initFieldList()
        },
    },
    mounted() {
        // 组件挂载后获取活动层级列表
        this.getActivityList()
    },
    methods: {
        // 获取活动层级列表
        async getActivityList() {
            let params = [
                'activity_level'
            ];
            newApplicationFormApi.getActivityList(params).then(res => {
                const { data } = res

                this.activityLevelList = data.activity_level
            })

            await this.initFieldList()
        },
        // 弹窗关闭时重置表单并通知父组件
        dialogCloseHandle() {
            this.$refs.addConfigForm.resetFields();
            this.$emit('dialogCloseHandle');
        },
        // 确认按钮处理，校验表单并提交
        customAddHandle() {
            this.$refs.addConfigForm.validate((valid) => {
                if (valid) {
                    let ruleCondition = []
                    let isNext = true

                    this.configList.forEach(item => {
                        let ruleRow = []
                        console.log(item)
                        // item的元素个数
                        if (Object.keys(item).length <= 0) {
                            isNext = false
                        }
                        for (let i in item) {
                            const row = item[i]
                            if (row.data.type === 'checkbox') {
                                if (row.value.length <= 0) {
                                    isNext = false
                                }
                                ruleRow.push({
                                    field: i,
                                    operator: 'in',
                                    value: row.value.join(','),
                                })
                            }
                            if (row.data.type === 'checkinput') {
                                if (row.value.radio === '' || row.value.input === '') {
                                    isNext = false
                                }
                                ruleRow.push({
                                    field: i,
                                    operator: row.value.radio,
                                    value: row.value.input ? row.value.input : 0,
                                })
                            }
                        }
                        ruleCondition.push(ruleRow)
                    })
                    if (isNext) {
                        const form = {
                            activityLayering: this.formData.activityLayering,
                            applyChannel: this.formData.applyChannel,
                            sort: parseInt(this.formData.sort),
                            stat: parseInt(this.formData.stat),
                            ruleCondition: ruleCondition
                        }
                        if (this.editData.id) {
                            // 编辑模式，调用更新接口
                            activityRuleApi.updateRule({ ...form, id: this.editData.id }).then(res => {
                                if (res.status === '200') {
                                    this.search()
                                    this.dialogCloseHandle()
                                }
                            })
                        } else {
                            // 新增模式，调用新增接口
                            activityRuleApi.addRule(form).then(res => {
                                if (res.status === '200') {
                                    this.search()
                                    this.dialogCloseHandle()
                                }
                            })
                        }
                    }else{
                        // 校验未通过，弹出提示
                        this.$message({
                            message: '所选条件对应值不能为空',
                            type: 'error'
                        })
                    }
                }
            })
            // this.$refs['addConfigForm'].validate((valid) => { })
            // this.$emit('customAddHandle');
            // this.$refs.configRule.insertUpdateData()
        },
        // 取消按钮处理
        customCloseHandle() {
            this.$emit('dialogCloseHandle');
        },
        // 排序输入过滤，只允许数字
        inviterNumFilter(prop, val) {
            // let numVal = val.replace(/[^\d]/g, '').replace(/^0{1,}/g, '');
            // 允许所有数字
            let numVal = val.replace(/[^\d]/g, '')
            this.$set(this.formData, prop, numVal);
        },
        // 缓存修改前的afc select value
        visibleAfc() {
            this.afcCache = JSON.parse(JSON.stringify(this.formData.applyChannel));
        },
        // 申请渠道切换时，缓存和恢复对应的 configList
        async changeAfc() {
            if (this.afcCache !== this.formData.applyChannel) {
                this.configListCache[this.afcCache] = JSON.parse(JSON.stringify(this.configList))
                // this.configListCache[this.afcCache] = this.configList
                this.configList = []
                this.$nextTick(() => {
                    if (this.configListCache[this.formData.applyChannel]) {
                        this.$set(this, "configList", this.configListCache[this.formData.applyChannel])
                    } else {
                        this.configList = [{}]
                    }
                })
            }

            await this.initFieldList()
        },
        // 初始化字段列表，根据申请渠道不同返回不同字段
        async initFieldList() {
            let params = [
                // 活动分类
                'activity_classification',
                // 活动形式
                'activity_forms',
                // 主办方
                'organizer',
                // 主要目标对象
                'target_object',
                // 申请分类
                'other_classification'

            ];
            const more = await newApplicationFormApi.getActivityList(params)

            const typeList = await newApplicationFormApi.getActivityTypeList('全部')
            let data = []
            if (this.formData.applyChannel === this.afcList[0].fieldKey) {
                // 活动申请、活动报备
                data = [
                    {
                        id: 0,
                        label: "活动分类",
                        type: "checkbox",
                        prop: "activityClassify",
                        options: this.dataSet(more.data.activity_classification)
                    },
                    {
                        id: 1,
                        label: "活动形式",
                        type: "checkbox",
                        prop: "activityForm",
                        options: this.dataSet(more.data.activity_forms)
                    },
                    {
                        id: 2,
                        label: "主办方",
                        type: "checkbox",
                        prop: "sponsor",
                        options: this.dataSet(more.data.organizer)
                    },
                    {
                        id: 3,
                        label: "拟邀请人数",
                        type: "checkinput",
                        prop: "invitePeopleNum"
                    },
                    {
                        id: 4,
                        label: "主要目标对象",
                        type: "checkbox",
                        prop: "mainTarget",
                        options: this.dataSet(more.data.target_object)
                    },
                    {
                        id: 5,
                        label: "活动类型",
                        type: "checkbox",
                        prop: "activityType",
                        options: this.dataSet(typeList.data)
                    },
                    {
                        id: 6,
                        label: "拟邀请单位数",
                        type: "checkinput",
                        prop: "inviteUnitsNum"
                    },
                    {
                        id: 7,
                        label: "3个月内预计新建业务机会数",
                        type: "checkinput",
                        prop: "threeMonthsNewOpp"
                    },
                    {
                        id: 8,
                        label: "预计3个月内推动业务机会数",
                        type: "checkinput",
                        prop: "threeMonthsPromoteOpp"
                    },
                ]
            }

            if (this.formData.applyChannel === this.afcList[1].fieldKey) {
                // 快捷申请
                data = [
                    {
                        id: 0,
                        label: "申请分类",
                        type: "checkbox",
                        prop: "quickClassify",
                        options: this.dataSet(more.data.other_classification)
                    },
                    {
                        id: 1,
                        label: "活动分类",
                        type: "checkbox",
                        prop: "quickActivityClassify",
                        options: this.dataSet(more.data.activity_classification)
                    },
                ]
            }
            this.fieldList = data
        },
        // 数据整理，将接口返回的列表转为组件需要的格式
        dataSet(list) {
            return list.map(row => {
                return { id: row.id, value: row.fieldValue, label: row.fieldValue }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
// 表单项底部间距调整
.el-form-item {
    margin-bottom: 0px;
}
</style>